export const prop = {
  tv: 'https://agrotv.az/',
  // host: 'api-msp.vac.az/api/v1',
  host: 'api.agrobirja.az/api/v1',
  // host: 'test.agrobirja.az/api/v1',
  appKey: ''
};
